(function () {
  'use strict';

  var selector = '[data-section-type="product"]';
  var noticeClass = 'bf-quantity-limit-notice';

  function asNumber(value) {
    var number = Number(value);
    return Number.isFinite(number) ? number : null;
  }

  function inventoryFor(section, variant) {
    if (!section || !variant || !window.inventories) return null;
    var productId = String(section.getAttribute('data-product-id') || '');
    var productInventory = window.inventories[productId];
    return productInventory ? productInventory[variant.id] || null : null;
  }

  function selectedVariant(section) {
    var variantId = section.querySelector('[name="id"]')?.value;
    var variantsJson = section.querySelector('[data-variant-json]');
    if (!variantId || !variantsJson) return null;

    try {
      return JSON.parse(variantsJson.textContent || '[]').find(function (variant) {
        return String(variant.id) === String(variantId);
      }) || null;
    } catch (error) {
      return null;
    }
  }

  function inputFor(element) {
    if (element?.matches?.('input[name="quantity"]')) return element;
    return element?.closest?.('.js-qty__wrapper')?.querySelector('input[name="quantity"]') || null;
  }

  function getNotice(input) {
    var wrapper = input.closest('.js-qty__wrapper') || input.parentElement;
    if (!wrapper) return null;
    var notice = wrapper.parentElement?.querySelector('.' + noticeClass);
    if (!notice) {
      notice = document.createElement('p');
      notice.className = noticeClass;
      notice.hidden = true;
      notice.setAttribute('role', 'status');
      notice.setAttribute('aria-live', 'polite');
      wrapper.insertAdjacentElement('afterend', notice);
    }
    return notice;
  }

  function clearNotice(input) {
    var notice = getNotice(input);
    if (notice) {
      notice.hidden = true;
      notice.textContent = '';
    }
  }

  function showLimit(input, max) {
    var notice = getNotice(input);
    if (!notice) return;
    notice.textContent = 'Only ' + max + ' available for this option.';
    notice.hidden = false;
  }

  function maxForInput(input) {
    var value = asNumber(input.getAttribute('data-bf-max-quantity'));
    return value !== null && value >= 0 ? value : null;
  }

  function setLimit(section, variant, clearMessages) {
    var inventory = inventoryFor(section, variant);
    var max = inventory && inventory.policy !== 'continue' ? asNumber(inventory.quantity) : null;

    section.querySelectorAll('input[name="quantity"]').forEach(function (input) {
      if (max === null || max < 1) {
        input.removeAttribute('max');
        input.removeAttribute('data-bf-max-quantity');
        clearNotice(input);
        return;
      }

      input.setAttribute('max', String(max));
      input.setAttribute('data-bf-max-quantity', String(max));
      var current = asNumber(input.value);
      if (current !== null && current > max) {
        input.value = String(max);
        showLimit(input, max);
      } else if (clearMessages) {
        clearNotice(input);
      }
    });
  }

  function refreshSection(section, variant, clearMessages) {
    setLimit(section, variant || selectedVariant(section), clearMessages);
  }

  function refreshAll() {
    document.querySelectorAll(selector).forEach(function (section) {
      refreshSection(section);
    });
  }

  document.addEventListener('variant:change', function (event) {
    var detail = event.detail || {};
    document.querySelectorAll(selector).forEach(function (section) {
      if (detail.productId && String(detail.productId) !== String(section.getAttribute('data-product-id'))) return;
      refreshSection(section, detail.variant || null, true);
    });
  });

  document.addEventListener('input', function (event) {
    var input = inputFor(event.target);
    var max = input && maxForInput(input);
    var value = input && asNumber(input.value);
    if (max !== null && value !== null && value > max) {
      input.value = String(max);
      showLimit(input, max);
    }
  }, true);

  document.addEventListener('change', function (event) {
    var input = inputFor(event.target);
    var max = input && maxForInput(input);
    var value = input && asNumber(input.value);
    if (max !== null && value !== null && value > max) {
      input.value = String(max);
      showLimit(input, max);
    }
  }, true);

  document.addEventListener('click', function (event) {
    var plus = event.target.closest('.js-qty__adjust--plus');
    if (!plus) return;
    var input = inputFor(plus);
    var max = input && maxForInput(input);
    var value = input && asNumber(input.value);
    if (max !== null && value !== null && value >= max) {
      event.preventDefault();
      event.stopImmediatePropagation();
      showLimit(input, max);
    }
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    refreshAll();
    window.setTimeout(refreshAll, 1000);
    window.setTimeout(refreshAll, 2500);
    window.setTimeout(refreshAll, 5000);
  });

  new MutationObserver(function () {
    refreshAll();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
